// Post-Call-Mails (ADR 0368): die Vorlagen A bis I als DATEN. Eine Vorlage ist eine Folge von Teilen:
// feste Absätze und benannte PLÄTZE (Betreff, Anker, Problem, Beleg, Bitte, Anlass). Getauscht wird
// ein Platz, nicht die Mail; je Platz merkt sich der Versand, welcher Text benutzt und ob er
// angepasst wurde (Messung je Baustein, Plan PR 1/5).
//
// Schreibweise im Text: `{du|Sie}` = Anrede-Paar (lib/anrede.ts, links Du), `{token}` = wird aus dem
// Lead, dem Gespräch oder dem Profil gefüllt (postCallRender.ts). Quelle der Wortlaute:
// plans/post-call-mails/index.html, Abschnitt 03 bis 05. Keine Gedankenstriche in diesen Texten.

export type Platz = 'anker' | 'problem' | 'beleg' | 'bitte' | 'anlass';
export const PLAETZE: Platz[] = ['anker', 'problem', 'beleg', 'bitte', 'anlass'];
export const PLATZ_TITEL: Record<Platz, string> = {
  anker: 'Anker', problem: 'Problem', beleg: 'Beleg', bitte: 'Bitte', anlass: 'Anlass',
};

export type Fall = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G' | 'H' | 'I' | 'N';

export type Teil = string | { platz: Platz; text: string };

export interface PostCallVorlage {
  id: string;
  fall: Fall;
  titel: string;
  betreff: string;
  teile: Teil[];
  /** Plätze, die nicht leer sein dürfen (der Prüfer sperrt sonst). */
  pflicht: Platz[];
  /** Wortbereich laut Vorlagen-Seite; außerhalb nur ein Hinweis, keine Sperre. */
  woerter: [number, number];
  /** Wie viele Fragezeichen die Mail haben soll (genau eine Bitte). */
  fragen: number;
  /** Nur bis zur Q4-Frist (Gratistest vor Black Friday). */
  saison?: boolean;
  /** Nur, wenn wirklich angerufen wurde (F5). */
  nurNachAnruf?: boolean;
}

const HALLO = '{hallo}';
const SCHLUSS = '{abschied}\n{sig}';
const SCHLUSS_KURZ = '{abschied}\n{setter}';

export const POST_CALL_VORLAGEN: PostCallVorlage[] = [
  { id: 'A1', fall: 'A', titel: 'Bestätigung', betreff: '{terminKurz}: {firma} und fraud0',
    pflicht: ['anker', 'bitte'], woerter: [35, 85], fragen: 0,
    teile: [HALLO,
      { platz: 'anker', text: 'danke {dir|Ihnen} für das Gespräch eben. {satz}' },
      { platz: 'bitte', text: 'Die Einladung für {termin} ist unterwegs, mit {closer}. Vorbereiten {musst du|müssen Sie} nichts.' },
      'Falls etwas dazwischenkommt, {antworte|antworten Sie} einfach kurz, dann suchen wir einen neuen Termin.',
      SCHLUSS] },

  { id: 'B', fall: 'B', titel: 'Interesse, Termin offen', betreff: 'Google Ads bei {firma}: Termin mit {closerVorname}',
    pflicht: ['anker', 'problem', 'bitte'], woerter: [100, 190], fragen: 1,
    teile: [HALLO,
      { platz: 'anker', text: 'danke {dir|Ihnen} für die Zeit heute. {satz}' },
      { platz: 'problem', text: 'Genau da setzen wir an:\n1. Wir erkennen Klicks von Bots in {euren|Ihren} Google-Ads-Kampagnen in Echtzeit und sperren sie, bevor sie Budget kosten und {eure|Ihre} Kennzahlen verfälschen.\n2. Für bereits bezahlte ungültige Klicks stellen wir den Antrag auf Gutschrift bei Google, {du musst|Sie müssen} dafür nichts tun.' },
      { platz: 'beleg', text: 'Im Anhang ein One-Pager, zwei Minuten Lesezeit.' },
      { platz: 'anlass', text: 'Warum ich mich gerade jetzt melde: Google prüft ungültige Klicks nur für die letzten 60 Tage, und nur mit Belegen. Die gibt es erst ab dem Tag, an dem die Messung läuft. Wer vor dem Black Friday startet, kann die teuren Wochen bis Weihnachten später beantragen. Die Messung {könnt ihr|können Sie} 30 Tage kostenlos testen, und danach {entscheidet ihr|entscheiden Sie} in Ruhe.' },
      { platz: 'bitte', text: 'Wie am Telefon besprochen, schaut {closer} mit {dir|Ihnen} auf {euer|Ihr} Konto und sagt {dir|Ihnen} ehrlich, ob es sich lohnt. Passt es {dir|Ihnen} {zeitraum}? Dann schicke ich {dir|Ihnen} zwei Zeiten.' },
      SCHLUSS] },

  { id: 'B3', fall: 'B', titel: 'Antwort: zwei Zeiten', betreff: 'Re: Google Ads bei {firma}',
    pflicht: ['bitte'], woerter: [15, 50], fragen: 1,
    teile: [HALLO,
      { platz: 'bitte', text: 'super, dann [Anfang nächster Woche]: Passt {dir|Ihnen} [Montag, 10 Uhr] oder [Dienstag, 14 Uhr]? Ich schicke {dir|Ihnen} dann die Einladung.' },
      SCHLUSS_KURZ] },

  { id: 'C1', fall: 'C', titel: 'Ein Anhang und eine Wahlfrage', betreff: 'fraud0 in zwei Minuten',
    pflicht: ['anker', 'bitte'], woerter: [40, 95], fragen: 1,
    teile: [HALLO,
      { platz: 'anker', text: 'danke {dir|Ihnen} für das kurze Gespräch.' },
      { platz: 'beleg', text: 'Wie versprochen der One-Pager im Anhang, zwei Minuten Lesezeit.' },
      { platz: 'bitte', text: 'Damit ich {dir|Ihnen} danach nur das Passende schicke: Geht es {dir|Ihnen} eher um das Budget, das an Bots geht, oder um Kennzahlen, denen {du nicht mehr traust|Sie nicht mehr trauen}?' },
      SCHLUSS] },

  { id: 'D1', fall: 'D', titel: 'Weiterleit-Absatz', betreff: 'Für {kollege}: kurz zu Google Ads',
    pflicht: ['anker', 'problem', 'bitte'], woerter: [60, 120], fragen: 2,
    teile: [HALLO,
      { platz: 'anker', text: 'danke {dir|Ihnen} für den Hinweis auf {kollege}. Damit {du nichts schreiben musst|Sie nichts schreiben müssen}, hier ein Absatz zum Weiterleiten:' },
      { platz: 'problem', text: '„{kollegeVorname}, fraud0 erkennt Bot-Klicks in Google Ads und beantragt Gutschriften für bereits bezahlte ungültige Klicks. Ich fände einen kurzen Blick auf unser Konto sinnvoll. Magst du dich bei {setterVorname} melden: {telefon}?“' },
      { platz: 'bitte', text: 'Oder, wenn es {dir|Ihnen} lieber ist: Darf ich {kollege} direkt anschreiben und {dich|Sie} in Kopie setzen?' },
      SCHLUSS] },

  { id: 'E1', fall: 'E', titel: 'Zeitpunkt bestätigen', betreff: 'Wie besprochen: {spaeter}',
    pflicht: ['anker'], woerter: [25, 65], fragen: 0,
    teile: [HALLO,
      { platz: 'anker', text: 'danke {dir|Ihnen} für das Gespräch. Wie besprochen melde ich mich {spaeter}, wenn {spaeterGrund}. Bis dahin {hörst du|hören Sie} nichts von mir.' },
      { platz: 'bitte', text: 'Falls es vorher brennt: {telefon}.' },
      SCHLUSS_KURZ] },

  { id: 'E2', fall: 'E', titel: 'Zeitpunkt und Q4-Test', betreff: 'Wie besprochen: {spaeter}', saison: true,
    pflicht: ['anker', 'anlass'], woerter: [70, 140], fragen: 0,
    teile: [HALLO,
      { platz: 'anker', text: 'danke {dir|Ihnen} für das Gespräch. Wie besprochen melde ich mich {spaeter} wieder.' },
      { platz: 'anlass', text: 'Eine Sache gebe ich {dir|Ihnen} für vorher mit: Google prüft ungültige Klicks nur für die letzten 60 Tage, und nur mit Belegen ab dem Tag, an dem die Messung läuft. Black Friday und Weihnachten lassen sich also nur beantragen, wenn die Messung dann schon läuft.' },
      { platz: 'bitte', text: 'Die Messung {könnt ihr|können Sie} 30 Tage kostenlos testen, sie ist schnell eingerichtet, und danach {entscheidet ihr|entscheiden Sie} in Ruhe. Wenn {du das möchtest|Sie das möchten}, reicht ein kurzes Ja.' },
      SCHLUSS] },

  { id: 'F1', fall: 'F', titel: 'Neue Info und kleinste Frage', betreff: 'Re: Google Ads bei {firma}',
    pflicht: ['problem', 'bitte'], woerter: [40, 95], fragen: 1,
    teile: [HALLO,
      { platz: 'problem', text: 'eine Sache, die ich am Telefon nicht gesagt habe: Klicks von Bots kosten nicht nur den Klick. Sie verfälschen genau die Zahlen, nach denen {ihr|Sie} und Google die Gebote steuert, also Klickrate, Conversion-Rate und ROAS.' },
      { platz: 'bitte', text: 'Damit ich {dir|Ihnen} nicht das Falsche schicke, eine kurze Frage: {Betreust du|Betreuen Sie} Google Ads selbst, oder macht das eine Agentur?' },
      SCHLUSS_KURZ] },

  { id: 'F2', fall: 'F', titel: 'Erlaubnis-Frage', betreff: 'Re: Google Ads bei {firma}',
    pflicht: ['bitte'], woerter: [30, 80], fragen: 1,
    teile: [HALLO,
      { platz: 'bitte', text: 'ich will {dir|Ihnen} nicht hinterherlaufen, deshalb nur eine Frage: Passt das Thema gerade nicht, oder ist der Termin das Problem?\n\nWenn es gerade nicht passt, {sag|sagen Sie} mir einfach, wann ich mich wieder melden soll, dann trage ich mir das ein und {du hörst|Sie hören} bis dahin nichts von mir.' },
      SCHLUSS_KURZ] },

  { id: 'F3', fall: 'F', titel: 'Q4-Frist und Gratistest', betreff: 'Re: Google Ads bei {firma}', saison: true,
    pflicht: ['anlass', 'bitte'], woerter: [45, 95], fragen: 1,
    teile: [HALLO,
      { platz: 'anlass', text: 'noch ein Gedanke zur Jahreszeit: Google prüft ungültige Klicks nur für die letzten 60 Tage, und nur mit Belegen ab dem Tag, an dem die Messung läuft. Wer erst im Januar startet, kann Black Friday und Weihnachten nicht mehr beantragen.' },
      { platz: 'bitte', text: 'Die Messung {könnt ihr|können Sie} 30 Tage kostenlos testen und danach entscheiden. Soll ich {dir|Ihnen} die Schritte für den Test schicken?' },
      SCHLUSS] },

  { id: 'F4', fall: 'F', titel: 'Ein Beleg in einem Satz', betreff: 'Re: Google Ads bei {firma}',
    pflicht: ['beleg', 'bitte'], woerter: [30, 80], fragen: 1,
    teile: [HALLO,
      { platz: 'beleg', text: 'ein Beispiel, damit es greifbar wird: Bei {fallTyp} {fallBeleg}. Wie das bei {euch|Ihnen} aussieht, weiss ich erst nach der Messung.' },
      { platz: 'bitte', text: '{Interessiert dich|Interessiert Sie}, was das für {euer|Ihr} Konto hiesse? Ein Ja reicht.' },
      SCHLUSS] },

  { id: 'F5', fall: 'F', titel: 'Kanalwechsel: erst anrufen', betreff: 'Kurz angerufen', nurNachAnruf: true,
    pflicht: ['bitte'], woerter: [20, 50], fragen: 0,
    teile: [HALLO,
      { platz: 'bitte', text: 'ich habe {dich|Sie} eben kurz angerufen. Kein Stress: Wenn es gerade nicht passt, {sag|sagen Sie} mir einfach, wann es besser ist, oder {ruf|rufen Sie} zurück unter {telefon}.' },
      SCHLUSS_KURZ] },

  { id: 'G1', fall: 'G', titel: 'Thema schliessen', betreff: 'Re: Google Ads bei {firma}',
    pflicht: ['bitte'], woerter: [20, 50], fragen: 0,
    teile: [HALLO,
      { platz: 'bitte', text: 'ich nehme an, das Thema ist gerade nicht dran, und schliesse es bei mir. Falls ich falsch liege, reicht eine kurze Antwort, dann melde ich mich.' },
      SCHLUSS] },

  { id: 'H1', fall: 'H', titel: 'Weiches Nein: Frist nennen', betreff: 'Re: Google Ads bei {firma}', saison: true,
    pflicht: ['anker', 'anlass', 'bitte'], woerter: [80, 150], fragen: 0,
    teile: [HALLO,
      { platz: 'anker', text: 'danke {dir|Ihnen} für die ehrliche Antwort, das ist völlig in Ordnung.' },
      { platz: 'anlass', text: 'Nur eine Sache, damit {du sie für eure|Sie sie für Ihre} Planung {hast|haben}: Google prüft ungültige Klicks nur für die letzten 60 Tage, und nur mit Belegen. Die gibt es erst ab dem Tag, an dem die Messung läuft. Startet {ihr|Sie} erst im Januar, lassen sich Black Friday und Weihnachten später nicht mehr beantragen.' },
      { platz: 'bitte', text: 'Die Messung {könnt ihr|können Sie} 30 Tage kostenlos testen und danach entscheiden, ob {ihr weitermacht|Sie weitermachen}. Wenn {ihr das|Sie das} vorher noch angehen {wollt|wollen}, reicht ein kurzes Ja. Sonst melde ich mich {spaeter}.' },
      SCHLUSS_KURZ] },

  { id: 'H2', fall: 'H', titel: 'Tür offen', betreff: 'Re: Google Ads bei {firma}',
    pflicht: ['bitte'], woerter: [25, 70], fragen: 0,
    teile: [HALLO,
      { platz: 'bitte', text: 'alles klar, danke {dir|Ihnen}. Wenn es so weit ist, {erreichst du|erreichen Sie} mich direkt unter {telefon}, oder {du antwortest|Sie antworten} einfach auf diese Mail.\n\nIch melde mich {spaeter} einmal kurz, falls ich bis dahin nichts höre.' },
      SCHLUSS_KURZ] },

  { id: 'I1', fall: 'I', titel: 'Sauber beenden', betreff: 'Danke',
    pflicht: ['anker'], woerter: [10, 40], fragen: 0,
    teile: [HALLO,
      { platz: 'anker', text: 'danke {dir|Ihnen} für die klare Antwort, ich melde mich nicht mehr. Alles Gute für {euch|Sie}.' },
      SCHLUSS_KURZ] },

  // Freie kurze Mail im selben Faden (ADR 0368, Nachtrag): Anhang oder Link nachreichen, etwas
  // korrigieren. Zählt nicht als Follow-up der Kette; der Prüfer läuft trotzdem.
  { id: 'N1', fall: 'N', titel: 'Nachtrag im selben Faden', betreff: 'Re: Google Ads bei {firma}',
    pflicht: ['bitte'], woerter: [8, 80], fragen: 1,
    teile: [HALLO,
      { platz: 'bitte', text: '' },
      SCHLUSS_KURZ] },
];

export function vorlageById(id: string): PostCallVorlage | undefined {
  return POST_CALL_VORLAGEN.find((v) => v.id === id);
}

/** Vorlagen eines Falls in der Reihenfolge der Datei, ohne die, die jetzt nicht passen. */
export function vorlagenFuerFall(fall: Fall, opts: { saisonOffen: boolean; angerufen: boolean }): PostCallVorlage[] {
  return POST_CALL_VORLAGEN.filter((v) => v.fall === fall
    && (!v.saison || opts.saisonOffen)
    && (!v.nurNachAnruf || opts.angerufen));
}
